export * from './angularfire2';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// d:/xampp/htdocs/zenith-admin/~/angularfire2/index.js
// module id = ../../../../angularfire2/index.js
// module chunks = 4